import React, { Component } from 'react'

import { connect } from 'react-redux'

import { Button } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import { getDeal } from 'modules/billing/selectors'

import './style.css'

class DealErrorTemplate extends Component {
  componentDidMount() {
    const { deal, onMounted } = this.props

    if (deal.salesRepId) {
      window.drift.on('ready', () => {
        window.drift.config({ autoAssigneeId: deal.salesRepId })
      })
    }

    onMounted && onMounted()
  }

  openRepPlaybook = () => {
    window.drift.on('ready', () => {
      window.drift.api.openChat()
    })
  }

  render() {
    const { splashImage, header, description } = this.props

    return (
      <div className="deals-error-page">
        <Icon name="drift-logo-full" className="deal-error-drift-logo" />
        <div className="deals-error-body">
          <div className="deals-error-image-container">
            <img
              src={splashImage}
              alt="error splash"
              className="deals-expiration-splash-image"
            />
          </div>
          <h2>{header}</h2>
          <p>{description}</p>
          <Button onClick={this.openRepPlaybook}>Chat with your rep</Button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  deal: getDeal(state),
})

export default connect(mapStateToProps)(DealErrorTemplate)
